<script>
export default {
  methods: {
    getSellingUnitsArray() {
      // unfortunately sellingUnits sometimes gets mangled into an object
      const { sellingUnits } = this.$fischer.shopSettings();
      const sellingUnitsObject =
        typeof sellingUnits === 'object' ? Object.values(sellingUnits) : sellingUnits;

      return sellingUnitsObject;
    },
    getSellingUnit(code) {
      const sellingUnits = this.getSellingUnitsArray();

      if (sellingUnits) {
        const sellingUnit = sellingUnits.find((el) => el?.Code === code);

        if (sellingUnit?.Name_Short) {
          return sellingUnit.Name_Short;
        }
      }

      return code;
    },
    getSellingUnitInString(unitString) {
      let formattedUnitString = unitString;

      const sellingUnits = this.getSellingUnitsArray();
      if (sellingUnits) {
        sellingUnits.forEach((unit) => {
          if (!(unit?.Code && unit.Name_Short)) {
            return;
          }
          const reg = new RegExp(`\\b${unit.Code}\\b`);
          if (reg.test(formattedUnitString)) {
            formattedUnitString = unitString.replace(unit.Code, unit.Name_Short);
          }
        });
      }

      return formattedUnitString;
    },
  },
};
</script>
